import React, { useEffect, useState, useCallback, useContext, useRef } from 'react';
import AccountGroup from '../../../API/APIServices/AccountGroup';
import Account from '../../../API/APIServices/Account';
import ConfirmDeletionWithUserInput from '../../Props/ConfirmDeletionWithUserInput';
import CustomizeDeleteService from '../../../API/APIServices/CustomizeDeleteService';
import MyContext from '../../MyContext';



function AccountGroupCustomizeDelete({ setLoading }) {

    const [accountGroupList, setAccountGroupList] = useState([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isSoftDelete, setIsSoftDelete] = useState(true);
    const [isDeleteAccountOfGroups, setIsDeleteAccountOfGroups] = useState(true);
    const [isDeleteAccSubGroup, setIsDeleteAccSubGroup] = useState(true);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [isDropdownAccountGroupName, setIsDropdownAccountGroupName] = useState(false);
    const [accountGroupSuggestion, setAccountGroupSuggestion] = useState([]);
    const [accountGroupName, setAccountGroupName] = useState("");
    const [selectedAccountGroupName, setSelectedAccountGroupName] = useState("");
    const [accountGroupId, setAccountGroupId] = useState(0);

    const dropDownRef = useRef(null);
    const { debounce } = useContext(MyContext);


    async function fetchAccountGroup(page_num, account_group_id) {


        let filterToSend = [];

        if (account_group_id) {

            filterToSend.push({
                "fieldName": "idd2",
                "operatorName": "equal",
                "compareValue": account_group_id
            });

        }

        const filter = {
            "filter": filterToSend,
            "order": [
                {
                    "propertyName": "string",
                    "ascending": true
                }
            ],
            "pageNumber": page_num,
            "pageSize": pageSize
        };

        try {
            const response = await AccountGroup.GetAccountGroupsFilter2(filter);

            if (response.data.isSuccess) {

                const list = response.data.result.map((item) => {

                    item.isSelected = false;
                    return item;
                });

                setAccountGroupList(list);
                setTotalRecords(response.data.totalRecords);
            } else {
                console.log("Error When Fetching Account Group:", response.data.errorMessages);
            }

        } catch (error) {
            console.log("Error When Fetching Account Group:", error?.response?.data?.errorMessages);
        }
    }

    useEffect(() => {
        fetchAccountGroup(page, accountGroupId);
    }, [page, accountGroupId]);

    function handlePrevClick() {

        if (page <= 1) return;

        setPage(page - 1);
    }

    function handleNextClick() {

        if (page >= Math.ceil(totalRecords / pageSize)) return;

        setPage(page + 1);
    }

    function handleAccountGroupListSelect(e, index) {

        const bool = e.target.checked;

        let tempAccountGroupList = [...accountGroupList];
        tempAccountGroupList[index].isSelected = bool;

        setAccountGroupList(tempAccountGroupList);
    }

    useEffect(() => {

        console.log("accountGroupList", accountGroupList)
    }, []);

    async function handleDelete() {

        setLoading(true);

        try {

            const accGroup_D2Id = accountGroupList.filter(item => item.isSelected).map(item => item.idd2);


            const data = {
                "accGroup_D2Id": accGroup_D2Id,
                "deleteAccSubGroup": isDeleteAccSubGroup,
                "deleteAccOfGroups": isDeleteAccountOfGroups,
                "softDelete": isSoftDelete
            }

            console.log("data", data);
            
            const response = await CustomizeDeleteService.DeleteAccountGroupsAsync(data);

            if (response.data.isSuccess) {

                alert("Account Group Deleted Successfully!");
                fetchAccountGroup(page, accountGroupId);
            } else {
                console.log("Error in Account Group Custom Delete", response?.data?.errorMessages);
                alert("Failed to delete!")
            }

        } catch (e) {
            console.log("Error in Account Group Custom Delete", e?.response?.data?.errorMessages);
            alert("Failed to delete!")
        }

        setLoading(false);
    }

    const fetchSuggestions = async (name, value, GroupId, MasterType) => {

        const filteredData = {
            MasterType: MasterType,
            GroupWiseSuggestion: true,
            GroupId: GroupId,
            search_str: value,
            PageNumber: 1,
            PageSize: 50,
        };

        try {
            const SearchItem = await Account.GetAccountListForAutoSuggestion(
                filteredData
            );

            if (SearchItem) {
                return SearchItem;
            } else {
                return [];
            }
        } catch (error) {
            console.error("Error fetching account suggestions:", error);
            return [];
        }
    };


    const debouncedFetchAccountGroupSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 1);

            setAccountGroupSuggestion(SearchItem);
            setIsDropdownAccountGroupName(true);

        }, 500),
        []
    );

    const handleAccountGroupNameChange = (e) => {

        setAccountGroupName(e.target.value);
        setSelectedAccountGroupName("");
        setAccountGroupId(0);
        debouncedFetchAccountGroupSuggestions("AccountGroupName", e.target.value, '');
    }

    const handleAccountGroupNameSelection = async (id, name) => {

        console.log(id, name)
        setAccountGroupName(name);
        setAccountGroupId(id);
        setSelectedAccountGroupName(name);
        setIsDropdownAccountGroupName(false);
    };

    useEffect(() => {

        function handleClickOutside(event) {

            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setIsDropdownAccountGroupName(false);
            }
        }


        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);


    return (
        <div className='padding-20'>

            <div className="company_info-text-im relative">
                Account Group Deletion
                <button onClick={() => setConfirmDeleteOpen(!confirmDeleteOpen)} className="product-price-account-wise-delete-button customize-delete-button">Delete</button>

            </div>


            <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "15px" }}>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isSoftDelete}
                    onChange={((e) => setIsSoftDelete(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Soft Delete</span>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isDeleteAccountOfGroups}
                    onChange={((e) => setIsDeleteAccountOfGroups(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Delete Account Of Groups</span>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isDeleteAccSubGroup}
                    onChange={((e) => setIsDeleteAccSubGroup(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Delete Account Sub Groups</span>
            </div>

            <div className="search_panel_hd1">
                <div style={{ width: "60%" }}>
                    <div className="col-sm-n1" style={{ width: "100%", alignItems: "center" }}>

                        <div ref={dropDownRef} className="group_head" style={{ position: "relative" }}>
                            <input style={{ width: "90%" }} value={accountGroupName} onChange={handleAccountGroupNameChange} onClick={() => {

                                debouncedFetchAccountGroupSuggestions("AccountGroupName", accountGroupName, '')
                            }
                            } placeholder="Account Group Name" type="text" className="bill_panel_input" />


                            {isDropdownAccountGroupName && (
                                <ul
                                    style={{ position: "absolute", top: "35px" }}
                                    className="ItemmasterDuggestionsaleinvoice"

                                >
                                    {accountGroupSuggestion.map((agName, index) => (
                                        <li
                                            key={index}

                                            onClick={() =>
                                                handleAccountGroupNameSelection(
                                                    agName.id,
                                                    agName.name
                                                )
                                            }
                                        >
                                            {agName.name}
                                        </li>
                                    ))}
                                </ul>
                            )}

                        </div>

                    </div>
                </div>


            </div>

            <div className='customize-delete-table-overflow'>
                <table className="lens-stock-table">

                    <thead>
                        <tr>

                            <th style={{ width: "50px" }} className="lens-stock-table-th">S.No.</th>
                            <th style={{ width: "50px" }} className="lens-stock-table-th">Select</th>
                            <th className="lens-stock-table-th">Account Group Id</th>
                            <th className="lens-stock-table-th">Product Group Name</th>

                        </tr>
                    </thead>

                    <tbody>

                        {accountGroupList.map((item, index) => {

                            if (index % 2 === 0) {

                                return (
                                    <tr key={index} className="TrLensCreation" style={item.isSelected ? { backgroundColor: "#beddfc" } : {}}>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{(page * index) + 1}</td>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                            <input checked={item.isSelected} onChange={(e) => handleAccountGroupListSelect(e, index)} type="checkbox" />
                                        </td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.idd2}</td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.name}</td>
                                    </tr>
                                );

                            } else {
                                return (
                                    <tr key={index} className="TrLensCreation customize-delete-alternate-color" style={item.isSelected ? { backgroundColor: "#beddfc" } : {}}>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{(page * index) + 1}</td>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                            <input checked={item.isSelected} onChange={(e) => handleAccountGroupListSelect(e, index)} type="checkbox" />
                                        </td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.idd2}</td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.name}</td>
                                    </tr>
                                );
                            }

                        })}

                    </tbody>
                </table>
            </div>


            <div style={{ backgroundColor: "#E1EFFD", justifyContent: "end", marginTop: "5px", padding: "10px 0px", borderRadius: "4px" }} className="flex">

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "25%" }}>
                    <button disabled={page <= 1 ? true : false} onClick={handlePrevClick} class="table-list-button">
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <span class="table-list-page-txt">Page - <strong style={{ margin: "0px 3px;" }}>{page} of {Math.ceil(totalRecords / pageSize)}</strong></span>
                    <button disabled={page >= Math.ceil(totalRecords / pageSize) ? true : false} onClick={handleNextClick} class="table-list-button">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>

            {confirmDeleteOpen && <ConfirmDeletionWithUserInput
                HeadingTop="Are you sure you want to delete!"
                closeButtonClick={() => { setConfirmDeleteOpen(false) }}
                onYesClick={handleDelete}
            />}
        </div>
    );
}

export default AccountGroupCustomizeDelete;